export default {
  upload_common: {
    required: 'This question is mandatory',
    max_length_500: 'Please answer within 500 words.',
    please_enter_a_number: 'Enter numbers',
    unexpected_error: 'An unexpected error happened',
    temporarily_saved: 'Saved',
    unanswered_items: 'There are unanswered questions',
    answer_questionnaire_select: 'Select a survey',
    entry: 'Please write your answer.',
    target_select: 'Select',
    value_unit: 'Number',
    unit: 'Unit',
    attach_documents: 'Attach files',
    textarea_placeholder:
      'Please write your answer when required, or if you would like to add any supplementary explanation.',
    textarea_placeholder_with_file:
      '※Please indicate the relevant page of the attached evidence. \n Additionally, if any descriptions are required or supplementary information needs to be provided, please fill in the details here.',
    temporary_storage: 'Save',
    submit: 'Submit',
    last_saved_temporary: 'Last updated',
    There_are_unanswered_questions: 'There are unanswered questions',
    submitted_text: 'This survey has been submitted.',
    submitted_at: 'Submission Date',
    withdrawal_of_answer: 'Withdraw submission',
    withdrawal_accepted: 'Withdrawal accepted',
    help: 'Help',
    example_of_evidence: 'Example of evidence',
    save_temporary_answer: 'Save Survey',
    saved_temporary_answer: 'Your answer has been saved.',
    submit_answer: 'Submit Survey',
    confirm_submit_answer: 'Are you sure you want to submit the survey?',
    recommend_asuene: 'Would you recommend Asuene ESG to other companies?',
    not_at_all: 'Not at all',
    absolutely: 'Absolutely',
    let_us_know_your_thoughts: 'Let us know your thoughts or feedback.',
    thank_you_for_your_cooperation: 'Thank you for your cooperation.\nYour feedback will be used to improve our service.\n\nWe appreciate your continued support.',
    confirm_submit_shared_text: '\nYour responses to the survey will be shared to your buyer.',
    complete_submit_answer: 'Survey has been submitted. \nThank you for your cooperation.',
    back_answer: 'Return',
    close: 'Close',
    save_temporary_answer_and_prev: 'Save and go back',
    save_temporary_answer_and_next: 'Save and go next',
    prev: 'Back',
    next: 'Next',
    question_group_question_download: 'Download Survey',
    question_group_answer_download: 'Download Answers',
    question_group_download_answer_csv_title: 'Question・Answer(CSV)',
    question_group_download_answer_csv_description: 'Download answers in csv',
    question_group_download_answer_pdf_title: 'Question・Answer(PDF)',
    question_group_download_answer_pdf_description: 'Download answers in pdf',
    question_group_download_scorecard_pdf_title: 'Scorecard(PDF)',
    question_group_download_scorecard_pdf_description: 'Download score in pdf',
    question_group_download_esg_award_svg_title: 'ESG Award(SVG)',
    question_group_download_esg_award_svg_description: 'Download award in svg',
    question_group_download_esg_award_pdf_title: 'ESG Award(PDF)',
    question_group_download_esg_award_pdf_description: 'Download award in pdf',
    request_survey_withdrawal: 'Request survey withdrawal',
    survey_withdrawal_description: 'The withdrawal request will be sent to your Buyer. \nPlease indicate below the reason why you wish to withdraw your survey. The details of your request will be shared to your Buyer.',
    reason_withdrawal_request: 'Reason for withdrawal request',
    completed_withdrawal_request: 'Your withdrawal request has been accepted. \nPlease wait a few moments until your request is complete.',
    send: 'Send',
    cancel: 'Cancel',
    balloon_title_withdrawal_request: 'Your withdrawal request has been accepted.',
    no_survey: 'There are no survey requests available.',
    failed_to_save_before_export: 'Temporary save before download failed. Please check that the information entered is complete.',
    filter_unfilled_questions: 'Show only unanswered surveys',
    no_unfilled_questions: 'There are no unanswered questions.',
    move_page: 'Go to next page',
    confirm_move_page_message: 'Your answers are not saved.\nIf you move to a different page, your answers will be lost. Do you want to save your answers before moving?',
    confirm_without_save: 'Don’t save',
    confirm_with_save: 'Save',
    error_save: 'Could not save temporarily. Please check your answers.',
    there_are_no_unanswered_questions: 'There are no unanswered questions.',
    someone_editing_survey: 'Survey Under Edit',
    unable_edit_someone_editing_survey: 'The survey cannot be edited at the moment because there is a user currently editing it.',
    user_editing_survey: 'is currently editing.',
    reference_question: {
      see_previous_answers: 'See previous answers',
      previous_answers: 'Previous answers',
      overwrite_with_previous_answers: 'Overwrite with previous answers',
      submitted_at: '(Submitted {submitted_at})',
      related_question: 'See {target}',
      click_to_expand: 'Click to expand',
      click_to_omit: 'Click to omit',
      description: "You can copy answers from previously submitted surveys. Clicking 'Overwrite with previous answers' will automatically enter answers if there are any previous answers related with certain questions. If there are already answers entered in the survey, they will be overwritten.",
      answer_reference_function: 'Answer reference function',
      overwrite: 'Overwrite',
      overwrite_confirm: 'This action will fill in previous answers for questions which have been answered in previous surveys.\nAny questions that are already answered will be overwritten.',
      question_group: '@:question_group_section.list_header_question',
    },
    energy_question: {
      scope: 'Scope',
      item: 'Item',
      activity_amount: 'Amount',
      emission_factor: 'Emission factor',
      emission_amount: 'Emissions',
      unit_sale: 'Emission Intensity',
      total: 'Total',
      emission_amount_unit: 'tCO2',
      unit_sale_unit: 'tCO2/one million YEN',
    },
    label: {
      required_answer: 'Mandatory Answer',
      optional_answer: 'Optional Answer',
      conditional_required_answer: 'Branching Mandatory Answer',
      note: 'Note',
      evidence_attachments: 'Attach Evidence',
    },
    no_available_in_pdf: 'This question is not included in the output PDF.',
    comparison_question_meta: 'Question No.{questionDisplayNumber} of {categoryName}',
    comparison_reference_question_meta: 'Question No.{questionDisplayNumber} of {categoryName} of Survey {questionGroupName}',
    error_footer: 'There are uncorrected items.',
    error_panel_title: 'Review the corrections',
    error_panel_description: 'Please correct the following questions to submit.',
    error_panel_support_text_1: 'If the issue is not resolved, please contact',
    error_panel_support_label: 'support',
    error_panel_support_text_2: '.',
    error_panel_resolved: 'All errors have been resolved. You can submit now.',
    error: 'Error',
    error_revision_required: 'Revisions must be made for submission.',
    alert: 'Alert',
    alert_detected: 'The answer is away from the recommended value, but it can be submitted.',
    share_answer: {
      share_button: 'Share answer',
      modal_title: 'Share answer',
      description: "Please enter the recipient's email address. Upon registration, a viewing URL and password will be sent.",
      no_sharing_email: 'No email addresses are currently shared.',
      unshare: 'Unshare',
      not_shared: 'Sharing with {emails} has not been completed yet.',
      confirm_share_answer: 'Would you like to register the email address?',
      close_without_share: 'Close without registering',
      close_with_share: 'Register and close',
      not_register: '@:evaluation_dashboard.answer_transition.unregistered',
      confirm_unshare: 'Are you sure you want to unshare {email}?',
      shared: 'The answer has been shared',
    },
    question_group_download_answered_csv_title: 'Question・Answer(CSV)',
    question_group_download_answered_pdf_title: 'Question・Answer(PDF)',
    nps_reason: {
      question_text: 'Please tell us the reasons. (Multiple selections allowed)',
      options: {
        content_not_suitable: 'Not suitable for our company',
        too_many_questions: 'Too many or complex questions',
        insufficient_support: 'Insufficient support',
        hard_to_understand: 'Hard to understand',
        difficult_operation: 'Difficult to operate or input',
        slow_operation: 'Slow operation',
        other: 'Other',
      },
    },
    hide_conditional_questions: {
      modal: {
        title: 'Hide no answer required questions',
        description: 'Some questions do not require an answer depending on the selected content. \nDo you want to hide questions that do not require an answer?',
        submit: 'Set',
        checkbox_label: 'Hide no answer required questions from next time',
      },
    },
  },
}
